import Button from 'components/Button/Button';
import R2Icon from 'components/R2Icon/R2Icon';
import { useRegisterPasskey } from 'hooks/useRegisterPasskey';
import './RegisterDevice.scss';

const RegisterDevice = () => {
  const { registerPasskey, isLoading } = useRegisterPasskey();

  const registerDevice = async () => {
    try {
      await registerPasskey();
      alert("Device registered!");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="register-device">
      <div className="register-device__content-container">
        <div className="register-device__logo"><R2Icon /></div>
        <Button
          variant="outlined"
          text={isLoading ? "Registering..." : "Register Device"}
          onClick={registerDevice}
          disabled={isLoading}
          element='button'
        />
      </div>
    </div>
  );
};

export default RegisterDevice;